export default __webpack_public_path__ + "static/media/DNo.23-5.012c242e.jpg";